module.exports = __webpack_public_path__ + "home-block-4-overlay-Oy-o7Xn.png";